import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 9h-2a3 3 0 1 1 0 -6h7","key":"svg-0"}],["path",{"d":"M11 3v11","key":"svg-1"}],["path",{"d":"M15 3v11","key":"svg-2"}],["path",{"d":"M21 18h-18","key":"svg-3"}],["path",{"d":"M18 15l3 3l-3 3","key":"svg-4"}]]

const IconPilcrowRight = createReactComponent('outline', 'pilcrow-right', 'PilcrowRight', __iconNode);

export default IconPilcrowRight;